import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b1387c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "contact-details__heading" }, "راه های ارتباط با ما:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668E1",
    d: "M16.489 16.391c-4.311 4.393-7.888 6.719-10.632 6.719h-.03C4.11 23 3.8 22.3 2.73 21.665l.59.105-.699-.212C1.44 19.952.406 18.859.419 17.789c.015-1.257.94-2.154 2.111-3.288.286-.277.595-.577.922-.909 2.148-1.638 2.917-1.17 3.97-.794 1.148.41 2.138.764 4.215-1.351 2.076-2.116 1.73-3.126 1.329-4.296-.368-.371-.826-2.407.781-4.045 1.023-.336.627-.655.901-.948C15.756.969 16.632.3 17.863.13c1.07.07 2.123.521 3.703 2.131.021.021.085.086.104.109.61.356 1.308 1.303 1.319 3.153.511 2.8-2.171 6.457-6.5 10.868zm4.027-12.817a2.057 2.057 0 0 1-.117-.123C19.24 2.27 18.42 1.696 17.893 1.696h-.009c-.534.007-1.165.684-2.039 1.622-.283.302-.589.631-.93.978-.495.891-.722 1.332-.39 2.301.459 1.341 1.09 3.177-1.721 6.04-2.81 2.862-4.611 2.219-5.928 1.749-.949.084-1.383-.493-2.257.396-.337.343-.656.653-.95.937-.924.897-.899 1.543-.969 2.091-.06.537-.074 1.374 1.021 2.496.046.037.11.099.19.183.259.27.799.832 1.926.839h.02c1.579 0 4.5-1.068 9.464-6.127 4.99-5.083 6.026-8.063 6.016-9.668-.006-1.148-.556-1.696-.821-1.959zM8.407 4.3c.45-.391.881-.086.968.37a.842.842 0 0 1-.653.986c-.782.322-2.885 1.601-3.201 3.261-.076.401.469.68-.809.68a.785.785 0 0 1-.159-.015c-.448-.089-.74-.062-.653-.987.446-2.336 2.215-4.138 4.507-4.295zm.249-2.609c-3.718.42-6.146 3.819-7.023 7.147a.83.83 0 0 1-.912.742C.268 9.528.57 9.112.6 8.65.496 4.76 3.983.526 8.473.19c.455.29.861.109.912.572a.838.838 0 0 1-.729.929z"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "text-dark",
  href: "tel:02191008590"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "2500300"),
  /*#__PURE__*/_createTextVNode(" 0044 ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29",
  height: "26"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668E1",
    d: "M25.824 23.96c-1.353.487-3.107 1.202-5.075 1.202H8.219c-1.965 0-3.72-.715-5.073-1.202C1.64 21.589.81 19.466.81 17.116V8.363C.81 3.77 4.4.307 8.24.307h12.49c4.236 0 7.43 3.463 7.43 8.056v8.753c0 2.35-.83 4.473-2.336 6.844zm.428-15.597c0-3.56-2.322-6.144-5.522-6.144H8.24c-2.84 0-5.522 2.584-5.522 6.144v8.753c0 1.838.63 3.481 1.775 4.625a5.089 5.089 0 0 0 3.745 1.509H20.748c1.452 0 2.741-.522 3.729-1.509 1.145-1.144 1.775-2.787 1.775-4.625V8.363zm-9.309 6.317c-.716-.043-1.57.242-2.424.242-.851 0-1.701-.283-2.409-.182L6.404 9.465a.955.955 0 0 1 1.197-1.489l5.701 4.605c.868.572 1.948.57 2.446-.003l5.644-4.6a.953.953 0 0 1 1.342.139c.926.41.666 1.012-.139 1.345l-5.652 5.218z"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-dark",
    href: "mailto:support@paysara.org"
  }, "support@paysara.org")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "26"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668E1",
    d: "M16.458 25.43c-.238 0-.478.47-.713-.489a2.517 2.517 0 0 1-1.438-1.1l-4.844-7.866L1.527 11.5c-.573-.854-.973-.66-1.125-2.075C.251 8.764.365 8.84.724 7.51c.806-.526.837-.912 1.43-1.087L21.458.763a2.49 2.49 0 0 1 1.926.215 2.512 2.512 0 0 1 1.208 1.514c.134.468.131.96-.007 1.425l-5.71 19.313a2.506 2.506 0 0 1-1.21 1.503c-.377.207-.79.697-1.207.697zm-5.124-9.991 4.568 7.418c.085.139.215 1.103.369.284.342.094.706.299 1.509-.441l5.009-19.316c.037-.123.037-.251.002-.274-.048-.266-.159-.406-.312-.49a.66.66 0 0 0-.498-.056L2.682 8.223a.659.659 0 0 0-.37.282c-.093.15-.123.326-.084.795.04-.125.144.021.292.115l7.63 4.693 6.485-6.7c.365.002.958-.048 1.325-.007a.939.939 0 0 1 .007 1.326l-6.633 6.712z"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ما را دنبال کنید", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_detail_item = _resolveComponent("contact-detail-item")!
  const _component_contact_social_media = _resolveComponent("contact-social-media")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_contact_detail_item, { label: "شماره پشتیبانی" }, {
      icon: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_contact_detail_item, { label: "آدرس ایمیل" }, {
      icon: _withCtx(() => [
        _hoisted_5
      ]),
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_contact_detail_item, { label: "شبکه های اجتماعی" }, {
      icon: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }),
    _createVNode(_component_contact_social_media)
  ]))
}